



















import { Component, Mixins } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import { Company } from '@/api/model/company'
import { ReferralType, WidgetFlowType, WidgetInformationTopic } from '@/api/types'
import { Question } from '@/views/Form/Conversation.vue'
import Conversation from '@/views/Form/Conversation.vue'
import axios from 'axios'

const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''
const baseUrl = process.env.VUE_APP_KEYVUE_BACKEND_BASEURL

@Component({
    components: {
        Conversation,
    },
})
export default class Information extends Mixins(VhFixMixin) {
    company: Company = null
    companyLoading: boolean = true
    companyError: boolean = false
    submitted: boolean = null

    async mounted() {
        await this.loadCompany()
    }

    async loadCompany(): Promise<void> {
        this.companyLoading = true

        try {
            const response = await axios.get(`${baseUrl}${basePath}/companies/` + this.$route.query.company)
            this.company = Company.fromData(response.data)
            if ('companyName' in this.$route.query && this.$route.query.companyName.length) {
                this.company.branding.displayName = this.$route.query.companyName as string
            }
            this.$root.$currentCompany = this.company
        } catch (err) {
            this.companyError = true
        } finally {
            this.companyLoading = false
        }
    }

    get isFormEnabled(): boolean {
        if (!this.company || !this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.INFORMATION)) {
            return false
        }

        return true
    }

    get topics(): object {
        return this.company.widgetInformationTopics.map((topic: WidgetInformationTopic) => {
            return {
                label: topic.topic,
                value: topic.tag,
            }
        })
    }

    get questions(): Question[] {
        let questions: Question[] = [
            {
                question: `Hoi! Ik ben Emma van ${this.company.branding.displayName}. Meer informatie daar kan ik je zeker bij helpen. Wat is je voornaam?`,
                model: 'firstname',
                inputAttrs: {
                    name: 'Voornaam',
                },
            },
            {
                question: `Oké, ${this.answers.firstname}, over welke onderwerpen wil je meer weten?`,
                model: 'topics',
                input: 'multi-choice',
                inputAttrs: {
                    name: 'Tenminste één onderwerp',
                    options: this.topics,
                },
            },
            {
                question: `Ik ga ervoor zorgen dat jij meer informatie ontvangt over deze onderwerpen. Wat is jouw achternaam?`,
                model: 'lastname',
                inputAttrs: {
                    name: 'Achternaam',
                },
            },
            {
                question: `En naar welk e-mail adres mag ik het sturen?`,
                model: 'email',
                inputAttrs: {
                    name: 'E-mailadres',
                    rules: 'required|email',
                },
            },
            {
                question: `We hebben alles om jou de informatie te sturen. Alleen hebben wij nog conform de AVG jouw toestemming nodig om je gegevens op te mogen slaan conform de privacy voorwaarden van ${this.company.branding.displayName}. We gebruiken de gegevens alleen om te voldoen aan jouw verzoek en de opvolging daarvan.`,
                model: 'avg',
                choices: {
                    true: 'Ik ga akkoord',
                    false: 'Ik ga niet akkoord',
                },
                onValidate: (answer): true|string => {
                    if (answer === 'false') {
                        return 'We hebben jouw toestemming nodig om je de informatie te sturen.'
                    }

                    return true
                },
                afterLeave: async (): Promise<void>  => {
                    await this.submit()
                },
            },
        ]

        if (this.submitted === true) {
            questions = [].concat(questions, [
                {
                    question: `Bedankt, de informatie komt binnen enkele ogenblikken in jouw inbox.`,
                },
            ])
        } else if (this.submitted === false) {
            questions = [].concat(questions, [
                {
                    question: `Sorry, er is iets misgegaan. Probeer het later opnieuw.`,
                },
            ])
        }

        return questions
    }

    answers = {
        topics: null,
        firstname: null,
        lastname: null,
        email: null,
        avg: null,
    }

    async submit(): Promise<void> {
        this.submitted = null

        try {
            await axios.post(`${baseUrl}${basePath}/referrals/create`, {
                company: this.company.resourceIdentifier,
                source: 'emma',
                newSource: this.company.emmaSource?.resourceIdentifier,
                firstname: this.answers.firstname,
                lastname: this.answers.lastname,
                email: this.answers.email,
                type: ReferralType.INFORMATION,
                data: {
                    topics: this.answers.topics,
                    tag: this.$route.query.tag || null,
                    utm_source: this.$route.query.utm_source || null,
                    utm_medium: this.$route.query.utm_medium || null,
                    utm_campaign: this.$route.query.utm_campaign || null,
                    utm_term: this.$route.query.utm_term || null,
                    utm_content: this.$route.query.utm_content || null,
                    form_identifier: 'information_information',
                },
            })

            this.submitted = true
        } catch (err) {
            this.submitted = false
        }
    }
}
